import { Edit } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";

export default function EventAssignmentModalButton({
  eventDetailData,
  setEventModel,
  setShowAssignEventModal,
  useParagrah,
  canEdit,
  showEmptySpace,
}) {
  return (
    <Box className="flex gap-2 items-center w-full">
      {canEdit && (
        <button
          onClick={() => {
            setEventModel({
              ...eventDetailData,
              StateId: eventDetailData.State.Id,
              CityId: eventDetailData.City.Id,
              TeamId: eventDetailData.AssignedTeam?.Id,
              EventTypeId: eventDetailData.EventType?.Id,
              ClientId: eventDetailData.Client?.Id,
              StatusId: eventDetailData.CurrentStatus?.Id,
              ExpectedSolutionDateValue: !eventDetailData?.ExpectedSolutionDate
                ? null
                : new Date(eventDetailData?.ExpectedSolutionDate),
              ExpectedSolutionDate: eventDetailData?.ExpectedSolutionDate,
              ExpectedSolutionFinalDateValue:
                !eventDetailData?.ExpectedSolutionFinalDate
                  ? null
                  : new Date(eventDetailData?.ExpectedSolutionFinalDate),
              ExpectedSolutionFinalDate:
                eventDetailData?.ExpectedSolutionFinalDate,
              PersonalId: eventDetailData.PersonalAssigned?.id,
              VehicleId: eventDetailData.VehicleAssigned?.Id,
              ProceedingId: eventDetailData.ProceedingInfo?.Id,
            });
            setShowAssignEventModal(true);
          }}
        >
          <Edit
            style={{
              width: "20px",
              height: "20px",
              color: "#10366E",
            }}
          />
        </button>
      )}
      {!canEdit && showEmptySpace && <div style={{ width: "20px" }} />}
      {useParagrah ? (
        <p>{`${eventDetailData.PersonalAssigned.SurName} ${eventDetailData.PersonalAssigned.LastName}`}</p>
      ) : (
        <Typography>{`${eventDetailData?.PersonalAssigned?.SurName} ${eventDetailData?.PersonalAssigned?.LastName}`}</Typography>
      )}
    </Box>
  );
}
